import React, { useState } from "react";
import { reduxForm, formValueSelector } from "redux-form";
import validate from "./validate";
import FormOne from "./PageFormOne";
import FormTwo from "./PageFormTwo";
import FormThree from "./PageFormThree";
import FormFour from "./PageFormFour";
import { useSelector } from "react-redux";
import { sendGet } from "services/api";

import LogRocket from "logrocket";

const successMessageStyle = {
	padding: "20px",
	backgroundColor: "#d4edda",
	color: "#155724",
	marginTop: "20px",
	borderRadius: "5px",
	textAlign: "center"
};

const Create = ({ onSubmit, reset, events, change }) => {
	const [page, setPage] = useState(1);
	const [formData, setFormData] = useState({});

	const state = useSelector(state => state);

	const selector = formValueSelector("expositor_form");

	const done = selector(state, "done");
	const soldOut = selector(state, "soldOut");

	const onFormOneSubmit = data => {
		console.log(data);
		setFormData(prevData => ({ ...prevData, type: data }));
		setPage(2);
	};

	const onFormTwoSubmit = data => {
		if (data.type === "director") {
			if (!data.feapaes && !data.apae) {
				alert("Informe se você é coordenador da FEAPAES ou APAE");
				return;
			}
		}

		if (data.type === "coordinator") {
			if (!data.region && !data.local && !data.provincial) {
				alert(
					"Informe se você é coordenador de uma regional, estadual ou local"
				);
				return;
			}
		}

		if (data.type === "defender") {
			if (!data.region && !data.local && !data.provincial) {
				alert("Informe se você é autodefensor regional, estadual ou local");
				return;
			}
		}

		try {
			if (process.env.REACT_APP_LOG_ROCKET)
				LogRocket.identify(data.cpf.match(/\d/g).join(""), {
					name: `${data.name} ${data.lastname}`,
					email: data.email
				});
		} catch (e) {
			console.log(e);
		}

		change("loading", true);

		sendGet(`/user/public/${data.cpf}`)
			.then(response => {
				return response.json();
			})
			.then(result => {
				change("loading", false);
				if (!result?.model) {
					change("soldOut", true);
					return;
				}

				change(
					"events2",
					(result.model.events || []).reduce(
						(a, b) => ({ ...a, [b]: true }),
						{}
					)
				);

				setFormData(prevData => ({
					...prevData,
					...data,
					events: (result.model.events || []).reduce(
						(a, b) => ({ ...a, [b]: true }),
						{}
					)
				}));
				setPage(3);
			});
		setFormData(prevData => ({ ...prevData, ...data }));
		setPage(3);
		// onSubmit(data); // Submeter todos os dados acumulados para o backend
	};

	const onFormThreeSubmit = data => {
		setFormData(prevData => ({ ...prevData, ...data }));
		setPage(4);
		// onSubmit(data); // Submeter todos os dados acumulados para o backend
	};

	const onFormFourSubmit = data => {
		const finalData = { ...formData, ...data };
		onSubmit(finalData); // Submeter todos os dados acumulados para o backend
	};

	const previousPage = () => {
		setPage(page => Math.max(page - 1, 1));
	};

	const handleReset = () => {
		reset();
		setFormData({});
		setPage(1);
	};

	if (done) {
		return (
			<form className="form">
				<div className="form__form-group" style={successMessageStyle}>
					<p>Cadastro efetuado com sucesso!</p>
					<p>
						Esperamos você no XVIII CONGRESSO ESTADUAL DAS APAES SC, VIII FÓRUM
						DE AUTOGESTÃO E AUTODEFENSORIA, II FÓRUM DA FAMÍLIA.
					</p>
				</div>
				{/* <div className="account__btn__group">
					<button
						type="button"
						className="btn btn-primary account__btn account__btn--small"
						onClick={handleLogin}
					>
						Entrar
					</button>
				</div> */}
				<div className="account__btn__group">
					<button
						type="button"
						className="btn btn-secondary account__btn account__btn--small"
						onClick={handleReset}
					>
						Realizar novo cadastro
					</button>
				</div>
			</form>
		);
	}

	if (soldOut) {
		return (
			<form className="form">
				<div className="form__form-group" style={successMessageStyle}>
					<h3>Infelizmente as inscrições estão encerradas!</h3>
					<p>
						Lamentamos, mas não é mais possível realizar inscrições para o XVIII
						CONGRESSO ESTADUAL DAS APAES SC, VIII FÓRUM DE AUTOGESTÃO E
						AUTODEFENSORIA, II FÓRUM DA FAMÍLIA.
					</p>
				</div>
				{/* <div className="account__btn__group">
					<button
						type="button"
						className="btn btn-primary account__btn account__btn--small"
						onClick={handleLogin}
					>
						Entrar
					</button>
				</div> */}
				<div className="account__btn__group">
					<button
						type="button"
						className="btn btn-secondary account__btn account__btn--small"
						onClick={handleReset}
					>
						Voltar ao inicio
					</button>
				</div>
			</form>
		);
	}

	return (
		<div>
			{page === 1 && <FormOne handleSubmit={onFormOneSubmit} />}
			{page === 2 && (
				<FormTwo onSubmit={onFormTwoSubmit} previousPage={previousPage} />
			)}
			{page === 3 && (
				<FormThree onSubmit={onFormThreeSubmit} previousPage={previousPage} />
			)}
			{page === 4 && (
				<FormFour
					onSubmit={onFormFourSubmit}
					events={events}
					previousPage={previousPage}
				/>
			)}
		</div>
	);
};

export default reduxForm({
	form: "expositor_form", // Nome do formulário no Redux Form
	validate
})(Create);
